// User meta for Ripple admin
export const rippleAdminMeta = {
  dashboard_graph: true,
  dashboard_service_menu_invoice: true,
  dashboard_service_menu_report: true,
  dashboard_service_menu_ri: true,
  dashboard_service_menu: false,
  fees_credit: true,
  fees_fee: true,
  fees_refund: true,
  header_navi_ri: true,
  header_navi_invoice: true,
  usage_account: true,
  usage_account_graph: true,
  usage_account_menu: false,
  usage_account_menu_edit_account: true,
  usage_account_menu_budget: true,
  usage_account_menu_edit_budget: true,
  usage_account_menu_fees: true,
  usage_group: true,
  usage_group_graph: true,
  usage_tag: true,
  usage_tag_graph: true,
  ri_utilization: true,
  ri_recommendation: true,
};
